import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDetach = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.17701 7.72487L2.64087 10.262C1.78597 11.117 1.78597 12.5036 2.64087 13.3587C3.49601 14.2134 4.88243 14.2135 5.73755 13.3587L8.27368 10.8215L8.98169 11.5286L6.44458 14.0657L6.32544 14.179C5.07333 15.3098 3.14053 15.272 1.93384 14.0657C0.688394 12.8201 0.688394 10.8005 1.93384 9.55495L4.46997 7.01784L5.17701 7.72487ZM9.55493 1.93483C10.8005 0.689392 12.8199 0.688691 14.0657 1.93385L14.179 2.05299C15.2742 3.26477 15.2741 5.11464 14.179 6.32643L14.0657 6.44557L11.5295 8.98073L10.8225 8.2737L13.3586 5.73854C14.2138 4.88342 14.2138 3.496 13.3586 2.64088C12.5034 1.78619 11.117 1.78689 10.262 2.64186L7.72583 5.17702L7.01783 4.46998L9.55493 1.93483Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2.96921 2.96967C3.16449 2.77457 3.48102 2.77446 3.67624 2.96967L13.0298 12.3232C13.2248 12.5185 13.225 12.835 13.0298 13.0302C12.8345 13.2252 12.5179 13.2252 12.3227 13.0302L2.96921 3.6767C2.77394 3.48144 2.77394 3.16492 2.96921 2.96967Z",
		fill: "currentColor"
	})]
});
export default SvgDetach;
